// © Microsoft Corporation. All rights reserved.

import { customElement } from "@microsoft/fast-element";
import { SettingsTemplate as template } from "./Settings.template";
import { SettingsStyles as styles } from "./Settings.styles";
import { Settings as SettingsBase } from "./Settings";
import { SettingsLocalizedStrings, SettingsProps } from "./Interfaces";
/**
 * Microsoft News settings web component
 */
@customElement({
    name: "msn-settings",
    template,
    styles
})
class Settings extends SettingsBase { }

export {
    Settings,
    SettingsLocalizedStrings,
    SettingsProps
};
